import { ParticipantType } from 'src/types/handover';

type ParticipantNameInput = {
  type?: ParticipantType | string;
  companyName?: string;
  firstName?: string;
  lastName?: string;
};

export function getParticipantDisplayName(participant: ParticipantNameInput | null | undefined): string {
  if (!participant) return '';
  if (participant.type === ParticipantType.COMPANY) {
    const companyName = participant.companyName?.trim();
    const contactName = [participant.firstName, participant.lastName].filter(Boolean).join(' ').trim();

    if (companyName && contactName) return `${companyName} - ${contactName}`;
    return companyName || contactName || '';
  }
  return [participant.firstName, participant.lastName].filter(Boolean).join(' ');
}
